module.exports = __webpack_public_path__ + "static/media/avatar.5e946c20.svg";